import openpathConfig from 'openpathConfig';

import { shouldSaveMissing } from './saveMissingEnvConfig';

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const isLocizeWriteEnabled = shouldSaveMissing(
  openpathConfig.ENV,
  hostname,
);

// Always set explicitly: both plugins default to ['localhost'], which would allow writes from local machines.
const writeAllowedHosts = isLocizeWriteEnabled ? [hostname] : [];

export const locizeOptions = {
  projectId: openpathConfig.LOCIZE_PROJECTID,
  // Only include apiKey if defined (dev env). Production builds load from CDN (read-only).
  ...(openpathConfig.LOCIZE_APIKEY && { apiKey: openpathConfig.LOCIZE_APIKEY }),
  version: openpathConfig.LOCIZE_VERSION,
  referenceLng: openpathConfig.LOCIZE_REFLNG,
  cdnType: 'pro',
  // i18next-locize-backend (saveMissing)
  allowedAddOrUpdateHosts: writeAllowedHosts,
  // locize-lastused
  allowedHosts: writeAllowedHosts,
};
